<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Mi Email</h1></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2">
        <div class="text-p p-3">
            Mantené actualizados los datos de tu correo de contacto y suscripción
        </div>    
    </div>

    <div class="row-cols-12 m-2 mt-0">
        <div class="row p-3 mb-0 align-items-center">
            <div class="mb-3 mt-0 text-start ">
                <label for="email" class="form-label">Email</label>
                <input
                    id="email"
                    type="email"
                    class="form-control border-0 m-0 p-0 readonly-input"
                    [value]="email()"
                    readonly
                    autocomplete="off"
                    placeholder="ejemplo@email.com"
                />
            </div>
        </div>
        @if (error()) {
            <div class="alert alert-danger mt-4" role="alert">
                <small>{{ error() }}</small>
            </div>
        }
    </div>
</div>